import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../../../@core/services/user.service';
import { CompanyService } from '../../services/company.service';
import { CompanyResponse } from '../../models/response.module';

@Component({
  selector: 'app-create-event-org-selector-modal',
  standalone: false,
  templateUrl: './create-event-org-selector-modal.html',
})
export class CreateEventOrgSelectorModal implements OnInit {
  companies: CompanyResponse[] = [];
  loading: boolean = true;

  constructor(
    public modal: NgbActiveModal,
    private userService: UserService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.loadCompanies();
  }

  private loadCompanies() {
    this.loading = true;

    // Load personal company + user's organisation memberships in parallel
    forkJoin({
      personal: this.companyService.getOrCreatePersonalCompany().pipe(catchError(() => of(null))),
      relations: this.userService.getUserEntityRelation().pipe(catchError(() => of([])))
    }).subscribe({
      next: ({ personal, relations }) => {
        const personalCompany = personal as CompanyResponse | null;
        const orgRelations = relations || [];

        // Load full company details for each relation
        if (orgRelations.length > 0) {
          const companyRequests = orgRelations.map(rel =>
            this.companyService.getPublicCompanyById(rel.entity_id).pipe(catchError(() => of(null)))
          );

          forkJoin(companyRequests).subscribe({
            next: (orgs) => {
              const orgCompanies = (orgs.filter(c => c !== null) as CompanyResponse[])
                .filter(c => !c.is_personal);

              this.companies = [];
              if (personalCompany) {
                this.companies.push(personalCompany);
              }
              this.companies.push(...orgCompanies);
              this.loading = false;
            },
            error: () => {
              this.companies = personalCompany ? [personalCompany] : [];
              this.loading = false;
            }
          });
        } else {
          this.companies = personalCompany ? [personalCompany] : [];
          this.loading = false;
        }
      },
      error: () => {
        this.companies = [];
        this.loading = false;
      }
    });
  }

  selectCompany(company: CompanyResponse) {
    this.modal.close(company);
  }

  cancel() {
    this.modal.dismiss();
  }
}
